const requiredText = "Required";
const yesValue = "Yes";

const validateRequired = value => !value && requiredText;

const validateRequiredForHabits = (values, errors, member) => {
  const prefix = member !== "Emp" ? "Emp" : "";

  if (values[`${member}Smoke`] === yesValue && !values[`${member}SmokeQuantity`]) {
    errors[`${member}SmokeQuantity`] = requiredText;
  } else {
    errors[`${member}SmokeQuantity`] = undefined;
  }
  if (values[`${member}Smoke`] === yesValue && !values[`${member}SmokeNoOfYears`]) {
    errors[`${member}SmokeNoOfYears`] = requiredText;
  } else {
    errors[`${member}SmokeNoOfYears`] = undefined;
  }

  if (values[`${member}${prefix}ConsumeAlcohol`] === yesValue && !values[`${member}AlcoholType`]) {
    errors[`${member}AlcoholType`] = requiredText;
  } else {
    errors[`${member}AlcoholType`] = undefined;
  }

  if (
    values[`${member}${prefix}ConsumeAlcohol`] === yesValue &&
    !values[`${member}AlcoholQuantity`]
  ) {
    errors[`${member}AlcoholQuantity`] = requiredText;
  } else {
    errors[`${member}AlcoholQuantity`] = undefined;
  }

  if (values[`${member}Adventure`] === yesValue && !values[`${member}AdventureInfo`]) {
    errors[`${member}AdventureInfo`] = requiredText;
  } else {
    errors[`${member}AdventureInfo`] = undefined;
  }
};

const validateRequiredForHealth = (values, errors, member) => {
  if (values[`${member}Pregnant`] === yesValue && !values[`${member}PregnantDurationValue`]) {
    errors[`${member}PregnantDurationValue`] = requiredText;
  } else {
    errors[`${member}PregnantDurationValue`] = undefined;
  }
};

const validateForm = (values, { data }) => {
  const errors = {};
  Object.values(data).forEach(field => {
    if (field.isRequired && !values[field.fieldName] && !field.isReadOnly) {
      errors[field.fieldName] = requiredText;
    }
  });
  validateRequiredForHabits(values, errors, "Emp");
  validateRequiredForHabits(values, errors, "Sp");
  validateRequiredForHabits(values, errors, "Ch");

  validateRequiredForHealth(values, errors, "Emp");
  validateRequiredForHealth(values, errors, "Sp");
  validateRequiredForHealth(values, errors, "Ch");
  return errors;
};

export { validateForm, validateRequired };



// WEBPACK FOOTER //
// ./components/employee/hdf_forms/Ge/validation.js